const TONE_ICONS = {
  good: "pi pi-check-circle",
  warning: "pi pi-clock",
  bad: "pi pi-lock",
  neutral: "pi pi-minus-circle",
};

// Status sempre com ícone + texto, nunca só cor
const StatusBadge = ({ tone = "neutral", icon, children }) => (
  <span className={`admin-badge admin-badge--${tone}`}>
    <i className={icon || TONE_ICONS[tone]} aria-hidden="true" />
    {children}
  </span>
);

export default StatusBadge;
